import { render, staticRenderFns } from "./APPdevelopment.vue?vue&type=template&id=570f5872&scoped=true"
import script from "./APPdevelopment.vue?vue&type=script&lang=js"
export * from "./APPdevelopment.vue?vue&type=script&lang=js"
import style0 from "./APPdevelopment.vue?vue&type=style&index=0&id=570f5872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f5872",
  null
  
)

export default component.exports